module.exports = __webpack_public_path__ + "static/img/3-01.fc0860c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-01.png
// module id = 176
// module chunks = 1